const Target = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2947 2.05188C18.6528 2.17192 18.9127 2.48348 18.9666 2.85729L19.2374 4.73544L21.1401 5.0047C21.5162 5.05792 21.8297 5.31965 21.9492 5.68022C22.0687 6.04078 21.9736 6.43793 21.7038 6.70526L18.3027 10.0744C18.0355 10.3391 17.6425 10.4315 17.2854 10.3136L15.5985 9.75655L12.2546 13.0691C11.8622 13.4578 11.2291 13.4548 10.8404 13.0625C10.4517 12.6701 10.4547 12.037 10.847 11.6483L14.1845 8.34208L13.628 6.6881C13.5063 6.32653 13.601 5.92723 13.872 5.65875L17.2731 2.2896C17.5414 2.02379 17.9366 1.93184 18.2947 2.05188ZM16.1199 7.82249L17.3306 8.22226L18.8646 6.7026L18.2146 6.61062C17.7746 6.54834 17.4284 6.2031 17.365 5.76321L17.2704 5.10743L15.7223 6.64098L16.1199 7.82249ZM11.5508 5.05885C7.3717 5.05885 4 8.41241 4 12.5294C4 16.6465 7.3717 20 11.5508 20C15.7299 20 19.1016 16.6465 19.1016 12.5294C19.1016 11.9772 19.5493 11.5294 20.1016 11.5294C20.6539 11.5294 21.1016 11.9772 21.1016 12.5294C21.1016 17.7688 16.8167 22 11.5508 22C6.28495 22 2 17.7688 2 12.5294C2 7.29011 6.28495 3.05885 11.5508 3.05885C12.1031 3.05885 12.5508 3.50657 12.5508 4.05885C12.5508 4.61113 12.1031 5.05885 11.5508 5.05885ZM11.5508 9.29414C9.73294 9.29414 8.2754 10.7515 8.2754 12.5294C8.2754 14.3074 9.73294 15.7647 11.5508 15.7647C13.3687 15.7647 14.8262 14.3074 14.8262 12.5294C14.8262 11.9772 15.2739 11.5294 15.8262 11.5294C16.3785 11.5294 16.8262 11.9772 16.8262 12.5294C16.8262 15.4297 14.4554 17.7647 11.5508 17.7647C8.64619 17.7647 6.2754 15.4297 6.2754 12.5294C6.2754 9.6292 8.64619 7.29414 11.5508 7.29414C12.1031 7.29414 12.5508 7.74186 12.5508 8.29414C12.5508 8.84643 12.1031 9.29414 11.5508 9.29414Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Target;
